/* cl-lp-bf.js: the Black Friday landing page behaviours (ANZ 2026-10-10).
 *
 * 1. Mobile sticky bar (Figma 248:1819): shown once the hero CTA has scrolled
 *    out above the viewport, hidden while any [data-lpbf-hide-sticky] element
 *    (the HubSpot bands, the final CTA band) is on screen. Phones only (CSS
 *    hides it from 768px).
 * 2. Hero film: the source is set after window load (desktop file from 768px,
 *    the phone file below only when one is set), it plays only while the hero
 *    is in view and fades in once playing. Reduced motion: never started.
 * 3. HubSpot CTA guard: once HubSpot's CTA runtime is on the page it opens the
 *    VIP pop-up, so the fallback href must not also navigate (same guard as
 *    cl-campaign-footer; registered once per page).
 */
(function () {
  if (window.__lpbf) return;
  window.__lpbf = true;

  if (!window.__clHsCtaGuard) {
    window.__clHsCtaGuard = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-cl-hs-cta]');
      if (a && window.HubSpotCallsToActions) e.preventDefault();
    }, true);
  }

  var hasIO = 'IntersectionObserver' in window;

  /* 1. sticky bar */
  function sticky() {
    var bar = document.querySelector('[data-lpbf-sticky]');
    var cta = document.querySelector('[data-lpbf-hero-cta]');
    if (!bar || !cta || !hasIO) return;
    var past = false, blockers = 0, seen = new Map();
    function render() {
      var show = past && blockers === 0;
      bar.hidden = false;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; });
      render();
    }).observe(cta);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      blockers = 0;
      seen.forEach(function (v) { if (v) blockers++; });
      render();
    });
    document.querySelectorAll('[data-lpbf-hide-sticky]').forEach(function (el) { io.observe(el); });
    render();
  }

  /* 2. hero film */
  function film() {
    var v = document.querySelector('video[data-lpbf-video]');
    if (!v) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var mq = window.matchMedia('(max-width: 767px)');
    var inView = true;
    function src() { return mq.matches ? (v.dataset.srcMobile || '') : v.dataset.src; }
    function set() {
      var s = src();
      if (!s) { v.pause(); v.removeAttribute('src'); v.classList.remove('is-playing'); v.load(); return; }
      if (v.getAttribute('src') !== s) { v.setAttribute('src', s); v.load(); }
      play();
    }
    function play() {
      if (!v.getAttribute('src')) return;
      if (inView) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    if (hasIO) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; play(); }).observe(v);
    set();
    if (mq.addEventListener) mq.addEventListener('change', set); else mq.addListener(set);
  }

  function boot() { sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (document.readyState === 'complete') film(); else window.addEventListener('load', function () { setTimeout(film, 0); });
})();
